import React from 'react'

const AnimatedBurgerIcon = ({ isOpen, onClick, style = {} }) => {
  return (
    <button
      onClick={onClick}
      className={`burger-icon ${isOpen ? 'open' : 'close'}`}
      style={{
        background: 'none',
        border: 'none',
        color: 'var(--text-light)',
        fontSize: '24px',
        cursor: 'pointer',
        padding: '4px',
        borderRadius: 'var(--radius-sm)',
        transition: 'var(--transition-normal)',
        WebkitTapHighlightColor: 'transparent',
        touchAction: 'manipulation',
        minHeight: '44px',
        minWidth: '44px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...style
      }}
      onMouseEnter={(e) => {
        e.target.style.background = 'var(--medium-gray)'
      }}
      onMouseLeave={(e) => {
        e.target.style.background = 'none'
      }}
    >
      <div style={{
        width: '24px',
        height: '18px',
        position: 'relative',
        transform: isOpen ? 'rotate(45deg)' : 'rotate(0deg)',
        transition: 'transform 0.3s ease'
      }}>
        {/* Верхняя линия */}
        <div style={{
          position: 'absolute',
          top: isOpen ? '8px' : '0px',
          left: '0',
          width: '100%',
          height: '2px',
          backgroundColor: 'currentColor',
          transform: isOpen ? 'rotate(45deg)' : 'rotate(0deg)',
          transition: 'all 0.3s ease',
          transformOrigin: 'center'
        }} />
        
        {/* Средняя линия */}
        <div style={{
          position: 'absolute',
          top: '8px',
          left: '0',
          width: '100%',
          height: '2px',
          backgroundColor: 'currentColor',
          opacity: isOpen ? '0' : '1',
          transition: 'opacity 0.3s ease'
        }} />
        
        {/* Нижняя линия */}
        <div style={{
          position: 'absolute',
          top: isOpen ? '8px' : '16px',
          left: '0',
          width: '100%',
          height: '2px',
          backgroundColor: 'currentColor',
          transform: isOpen ? 'rotate(-45deg)' : 'rotate(0deg)',
          transition: 'all 0.3s ease',
          transformOrigin: 'center'
        }} />
      </div>
    </button>
  )
}

export default AnimatedBurgerIcon
